export enum UnblockStageEnum {
  INITIAL_UNBLOCK = "initial-unblock",
  PASS_UNBLOCK = "reset-by-pass",
  ERROR = "error-unblock",
  SUCCESS_EMAIL_SENT = "unlock-password",
  RESET_FLOW_ACTIVE = "reset-unblock",
  NEED_EDIT = "not-allow-to-reset",
}
